/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/digipass_corporate_medium'
export default icon
